import { render, staticRenderFns } from "./cadastrar-sumario.vue?vue&type=template&id=5ee4753f&"
import script from "./cadastrar-sumario.vue?vue&type=script&lang=js&"
export * from "./cadastrar-sumario.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-sumario.vue?vue&type=style&index=0&id=5ee4753f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports